import { CommonActionTypes } from "../../../action-types";
import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";

export const applyForNewAccount = (data) => async (dispatch) => {
  // dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    data.from_web = true;
    const res = await commonService.post("/client/mobile-requests/new-currency", data);

    return res.data;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
